/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectInstance} from "../models/object-instance";
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {ObjectCategory} from "../models/object-category";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class PeopleInstancesPagingResolver implements Resolve<PagedResults<ObjectInstance>> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ObjectInstance>> {
    try {
      return await this.mObjectService.getAllObjectInstancesForCategoryPaging(ObjectCategory.PEOPLE, 0,
        PAGING_ITEMS_PER_PAGE, 'ASC', "")
    } catch (error) {
      console.error("Problem resolving People Instances... Error: " + error, error);
    }
  }

}
